import { createTheme } from "@mui/material/styles";
// import { useSelector } from "react-redux";

const mode = 'light';
// const mode = useSelector(state => state.mode.value);

const theme = createTheme({
    palette: {
        // mode: 'light',
        mode,
        ...(mode === 'light' ? {
            primary: {
                main: '#A77BCA',  //violet
                light: '#B995D5',
                dark: '#9270AD',
                shade: '#fbf5ff'
            },
            secondary: {
                main: '#110C14' //dark text
            },
            success: {
                main: '#1B6F14',
                light: '#F2FDE2',
                shade: '#009873',
                dashboard: '#02C791',
            },
            error: {
                main: '#E64744',
                light: '#FDE2E2',
                dashboard: '#EF0107'
            },
            info: {
                main: '#5FD7FF',
                light: '#F4FCFF',
                dashboard: '#4AAADF'
            },
            warning: {
                main: '#F1B417',
                light: '#FFFCF3',
                dashboard: '#F9CC50'
            },
            text: {
                primary: '#3B3B3B',    //light
                secondary: '#110C14', //dark
                disabled: '#909090',
                grey: '#9E9E9E',  //grey-text
            },
            background: {
                default: '#FFF',     // applies to the body tag
                paper: '#FFF',
                tableHeader: '#F0EDF2',
                bgGrey: '#F8F8F8'
            },
            border: {
                main: '#EFEEF0'
            },
        } : {                                   //Assign Palette for dark Mode here
            primary: {
                // main: '#FB806C'
                main: '#696666'
            },
            background: {
                default: "#000",
            }
        })
    },

    typography: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: 13,
        fontWeight: 400,
        body1: {
            fontSize: 13,
            fontWeight: 400,
            // marginBottom: 8
        },
        body2: {
            fontSize: 13,
            fontWeight: 400,
            marginBottom: 8
        },
        subtitle1: {},
        subtitle2: {},
        h1: {
            fontSize: 32,
            fontWeight: 500,
            marginBottom: 8
        },
        h2: {
            fontSize: 24,
            fontWeight: 500,
            marginBottom: 8
        },
        h3: {
            fontSize: 20,
            marginBottom: 8,
            fontWeight: 700
        },
        h4: {
            fontSize: 18,
            marginBottom: 8,
        },
        // h5: {},
        h5: {
            fontSize: 16,
            fontWeight: 500,
            marginBottom: 8
        },
        h6: {
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 8
        },

        label: {
            fontSize: 13,
            fontWeight: 500,
            // marginBottom: 4,
            display: 'inline-block'
        },
        labelSm: {
            fontSize: 12,
            fontWeight: 400,
            marginBottom: 4,
            maxHeight: '18px'
        },
        link: {
            color: '#05344B',
            textDecoration: 'underline'
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: false,
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontWeight: 600,
                    lineHeight: 'normal',
                    fontSize: '1rem',
                    '@media screen and (max-width:900px)': {
                        padding: '4px 12px',
                    },
                    '&.Mui-disabled': {
                        background: '#E5D7EF',
                        color: '#FFF'
                    }
                }
            }
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontWeight: 400,
                    '& input': {
                        padding: '8px 12px',
                        fontSize: '1rem',
                        '::placeholder': {
                            color: '#7F7F7F',
                            opacity: 1
                        },
                    },
                    '& fieldset': {
                        borderColor: '#E1E1E0',
                        borderWidth: '1px',
                        borderRadius: '8px'
                    },
                    '&.Mui-disabled': {
                        background: '#F5F5F5',
                        borderColor: '#D8D8D8'
                    },
                    '&.Mui-disabled fieldset': {
                        borderWidth: '1px',
                        borderColor: '#D8D8D8'
                    },
                    '&.MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline ': {
                        borderColor: '#A77BCA',
                        borderWidth: '1px',
                    },
                    '&.Mui-focused fieldset': {
                        border: 'none',
                        boxShadow: '0 0 0 2.5px #E5D7EF',
                        borderWidth: '1px',
                    },
                    '&.Mui-error fieldset': {
                        borderColor: '#d32f2f',
                        borderWidth: '1px',
                    },

                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    '&.MuiTabs-root': {
                        '& .MuiButtonBase-root': {
                            fontSize: '1rem',
                            fontWeight: 400,
                            textTransform: 'capitalize',
                            '&.Mui-selected': {
                                fontWeight: 500
                            }
                        }
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    // boxShadow: 'none'
                    boxShadow: '0px 4px 20px 0px #E7DEEE33',
                    borderRadius: '10px',
                    '&.MuiPaper-outlined': {
                        borderColor: '#EFEEF0'
                    },
                    '&.MuiPopover-paper': {
                        boxShadow: '0px 4px 20px 0px #0000001F'
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    height: 24,
                    lineHeight: 'normal'
                }
            }
        },
        MuiPickersPopper: {
            styleOverrides: {
                root: {
                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px'
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '11px',
                    marginLeft: '12px',
                    marginTop:' 3px',
                    marginRight: '0',
                },
            },
        },
    }
})

export default theme 